// 1st nesting level is report locale. 2nd nesting level is i18n language.
// NOTE: We'll always display tips for Spanish tests in Spanish otherwise the recommendations aren't pedagogically sound.
const TIPS_URLS = {
  "EN-US": {
    "en-us": "https://amira-parent-tips.s3.amazonaws.com/parent_tips_8_2.json",
    "es-mx": "https://amira-parent-tips.s3.amazonaws.com/parent_tips_8_2_es_mx.json",
  },
  "ES-MX": {
    "en-us": "https://amira-parent-tips.s3.amazonaws.com/parent_tips_8_2_es_mx.json",
    "es-mx": "https://amira-parent-tips.s3.amazonaws.com/parent_tips_8_2_es_mx.json",
  }
}

export async function fetchTips(score, locale, i18nLanguage) {
  const tipsURL = TIPS_URLS[locale][i18nLanguage];
  if (!tipsURL) return null;

  const response = await fetch(tipsURL);
  const tips = await response.json();

  // Convert the input score to a floating-point number
  let parsedInputKey = parseFloat(score);
  if (isNaN(parsedInputKey)) {
    console.log('Invalid input score');
  } else {
    // Round to 1 decimal place
    parsedInputKey = Math.round(parsedInputKey * 10) / 10;
    if (isNaN(parsedInputKey)) {
      console.log('Rounding error occurred');
    }
  }

  const closestKeys = Object.keys(tips).map(parseFloat).sort((a, b) => Math.abs(a - parsedInputKey) - Math.abs(b - parsedInputKey)).slice(0, 3);
  const closestTips = closestKeys.map((key) => tips[key.toString()]);
  return closestTips
}

export async function fetchTranslatedTips(score, locale) {
  const fetchEnglishTips = fetchTips(score, locale, 'en-us');
  const fetchSpanishTips = fetchTips(score, locale, 'es-mx');
  const [englishTips, spanishTips] = await Promise.all([fetchEnglishTips, fetchSpanishTips]);
  return {
    'en': englishTips,
    'es': spanishTips,
  }
}